// @flow
import React from 'react';

type PropsType = {
  className: string,
};

const SamsungWatchComviqSvg = ({ className }: PropsType) => {
  return (
    <svg className={className} width="70" height="70" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <title>smart-watch-circle-alternate</title>
      <path d="M21.5,12A9.5,9.5,0,0,0,17,3.928a.25.25,0,0,1-.109-.148L15.983.373A.5.5,0,0,0,15.5,0h-7a.5.5,0,0,0-.483.371L7.108,3.779A.245.245,0,0,1,7,3.927,9.5,9.5,0,0,0,7,20.076a.25.25,0,0,1,.109.148l.908,3.407A.5.5,0,0,0,8.5,24h7a.5.5,0,0,0,.482-.369l.935-3.427a.247.247,0,0,1,.109-.146A9.5,9.5,0,0,0,21.5,12Zm-8.031,7.359a7.5,7.5,0,1,1,5.89-5.89A7.515,7.515,0,0,1,13.469,19.361Z" />
    </svg>
  );
};

export default React.memo(SamsungWatchComviqSvg);
